import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-video-wrapper">
          <iframe
            className="hero-video-iframe"
            src="https://www.youtube.com/embed/rRqVA9AHU3I?autoplay=1&mute=1&loop=1&playlist=rRqVA9AHU3I&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
            title="Partsol Hero Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="hero-overlay"></div>

        {/* Animated particles */}
        <div className="hero-particles">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
          <div className="particle particle-5"></div>
        </div>

        {/* Gradient glow */}
        <div className="hero-glow"></div>
      </div>

      <div className="hero-content">
        <img
          src="/partsol-main.png"
          alt="Partsol"
          className="hero-logo"
        />
        <p className="hero-tagline">Revealing What You've Yet to Find</p>
      </div>
    </section>
  );
};

export default Hero;
